import {
  CreateCustomSetupAreaRequest, ProjectType,
  SetupArea,
  TeamSetupArea, UpdateCustomSetupAreaRequest,
  useCustomSetupAreasService
} from 'nekst-api';
import React from 'react';
import {
  AfterSubmitFunc,
  Button,
  ButtonColor,
  FormTemplate,
  IconType,
  TextInput
} from 'ui-builder';
import { ProjectTypeDropdown } from 'features/tasks-forms';
import { TimezoneDropdown, usePopupFormManager } from 'features/nekst-widgets';
import { MarketTimezoneToggleWrapper } from 'feature-toggle';

export function CreateCustomSetupAreaForm(props: {
  afterSubmitFunc?: AfterSubmitFunc,
}) {

  const customSetupAreasService = useCustomSetupAreasService();

  return (
    <FormTemplate<CreateCustomSetupAreaRequest, SetupArea>
      title="Create Custom Process"
      submitFormFunc={async (data) => {
        return await customSetupAreasService.createCustomSetupArea(data);
      }}
      validationSchema={customSetupAreasService.getValidationSchema()}
      initialData={{
        projectType: ProjectType.OTHER,
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="name" label="Process Name" />
      <TextInput
        source="alias"
        label="Alias"
        hint="Alias is used in Zapier and Public API integrations"
      />
      <ProjectTypeDropdown source="projectType" label="Type" isClearable={false} />
      <MarketTimezoneToggleWrapper>
        <TimezoneDropdown source="timezone" label="Timezone" placeholder="Select timezone" />
      </MarketTimezoneToggleWrapper>
    </FormTemplate>
  );
}

export function UpdateCustomSetupAreaForm(props: {
  teamSetupArea: TeamSetupArea,
  afterSubmitFunc?: AfterSubmitFunc,
}) {
  const customSetupAreasService = useCustomSetupAreasService();

  return (
    <FormTemplate<UpdateCustomSetupAreaRequest, SetupArea>
      title={`Update "${props.teamSetupArea.name}"`}
      submitFormFunc={async (data) => {
        return await customSetupAreasService.updateCustomSetupArea(
          props.teamSetupArea.id,
          data,
        );
      }}
      validationSchema={customSetupAreasService.getValidationSchema()}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={{
        name: props.teamSetupArea.name,
        alias: props.teamSetupArea.alias,
        projectType: props.teamSetupArea.projectType,
        timezone: props.teamSetupArea.timezone,
      }}
    >
      <TextInput source="name" label="Process Name" />
      <TextInput
        source="alias"
        label="Alias"
        hint="Alias is used in Zapier and Public API integrations"
      />
      <ProjectTypeDropdown source="projectType" label="Type" isClearable={false} />
      <MarketTimezoneToggleWrapper>
        <TimezoneDropdown source="timezone" label="Timezone" placeholder="Select timezone" />
      </MarketTimezoneToggleWrapper>
    </FormTemplate>
  );
}


export function CreateCustomSetupAreaButton() {
  const popupFormManager = usePopupFormManager();

  return (
    <Button
      text="Create Custom Process"
      iconType={IconType.PLUS}
      isFilled
      color={ButtonColor.BLUE}
      onClick={async () => {
        popupFormManager.openForm(
          <CreateCustomSetupAreaForm />,
        );
      }}
    />
  )
}

